import * as z from 'zod';
import { CustomTFunction, getTranslation } from '../../../../../../utils';
import { formDurationInputSchema } from '../../../../../../components/molecules/FormComponents';

export const getAddToPlanFormSchema = (t: CustomTFunction) => {
  const validationT = getTranslation(t, 'forms.validation.messages');

  return z
    .object({
      queue: z.object({
        queueId: z.number(),
        name: z.string(),
        shortName: z.string(),
        suggestedStart: z.string(),
        suggestedEnd: z.string(),
      }),
      start: z.object({
        date: z.date(),
        time: z.string(),
      }),
      end: z.object({
        date: z.date(),
        time: z.string(),
      }),
      blockedStart: z.boolean(),
      hasCustomProductionDuration: z.boolean(),
      hasCustomRetoolingDuration: z.boolean(),
      overrideProductionDuration: formDurationInputSchema.optional(),
      overrideRetoolingDuration: formDurationInputSchema.optional(),
    })
    .superRefine((data, ctx) => {
      if (data.hasCustomProductionDuration) {
        const productionDuration = data.overrideProductionDuration;
        if (
          !productionDuration ||
          !Object.values(productionDuration).some((value) => value !== undefined && value > 0)
        ) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: validationT('inputRequired'),
            path: ['overrideProductionDuration'],
          });
        }
      }

      // TODO: if backend add this later
      // if (data.hasCustomRetoolingDuration) {
      //   const retoolingDuration = data.overrideRetoolingDuration;
      //   if (!retoolingDuration || !Object.values(retoolingDuration).some((value) => value !== undefined && value > 0)) {
      //     ctx.addIssue({
      //       code: z.ZodIssueCode.custom,
      //       message: validationT('inputRequired'),
      //       path: ['overrideRetoolingDuration'],
      //     });
      //   }
      // }
    });
};

export type AddToPlanFormSchema = z.infer<ReturnType<typeof getAddToPlanFormSchema>>;
